var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { useFormContext } from 'react-hook-form';
import { useGetSpaceByIdForDraftEventMeetingServicePermissionQuery } from '../../generated/graphql';
import { useUserPermissions } from '../hooks/useUserPermissions';
import { useSafeFormData, ComposerMode, } from '../types/index';
import { useEventApi } from '../hooks/useEvent/useEventApi';
import { useConfig } from '../context/ConfigContext';
import { defaultUseGetLocationLevelReturn, useGetLocationLevel, } from '../hooks/useLocationLevel/useGetLocationLevel';
var defaultEventComposerGlobalContextValue = __assign({ timezone: '', timeFormat: 'h:mm a', requestOnlySpace: undefined, requestFormId: undefined, spaceRequestFormCompletion: 'unknown', setSpaceRequestFormCompletion: function () { }, hasAttemptedSubmit: false, setHasAttemptedSubmit: function () { }, composerMode: ComposerMode.CREATE, backgrounded: false, onError: function () { }, onTrackBufferEvent: undefined, setSpaceBookingOpen: function () { }, pendingSpaceSwap: null, setPendingSpaceSwap: function () { }, removePendingSpace: function () { }, removeSpace: function () { }, spacesWithConflicts: null, isCheckingConflicts: false, updateSpaceConflicts: function () { }, clearSpaceConflict: function () { }, incrementConflictChecks: function () { }, decrementConflictChecks: function () { }, hasSpacesReservePublicPermissionForCurrentTenant: false, permissionsLoading: false }, defaultUseGetLocationLevelReturn);
var EventComposerGlobalContext = createContext(defaultEventComposerGlobalContextValue);
export var EventComposerGlobalProvider = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var children = _a.children, composerMode = _a.composerMode, timezone = _a.timezone, timeFormat = _a.timeFormat, onError = _a.onError, setSpaceBookingOpen = _a.setSpaceBookingOpen, onTrackBufferEvent = _a.onTrackBufferEvent, defaultLevelId = _a.defaultLevelId, _j = _a.backgrounded, backgrounded = _j === void 0 ? false : _j;
    var userPermissions = useUserPermissions();
    var setValue = useFormContext().setValue;
    var getValues = useFormContext().getValues;
    var formData = useSafeFormData();
    var _k = useConfig(), environmentUrls = _k.environmentUrls, userContext = _k.userContext, tenantId = _k.tenantId, accessToken = _k.accessToken;
    /* Source of truth for location and level */
    var _l = useGetLocationLevel(defaultLevelId), locationId = _l.locationId, levelId = _l.levelId, setLocationId = _l.setLocationId, setLevelId = _l.setLevelId, locationLevelLoading = _l.loading;
    var _m = __read(useState(null), 2), pendingSpaceSwap = _m[0], setPendingSpaceSwap = _m[1];
    // When the host backgrounds the composer (e.g. the office space-preview
    // flow takes the sider slot), close the add-space drawer — it portals to
    // document.body, so it would float over the sider that replaced us. A
    // pending "change space" swap is abandoned with it, mirroring the drawer's
    // own close handler (see SpaceBookingInternal). Drawers owned by deeper
    // components (suggested times) subscribe to `backgrounded` off this
    // context and close themselves the same way.
    useEffect(function () {
        if (backgrounded) {
            setSpaceBookingOpen(false);
            setPendingSpaceSwap(null);
        }
    }, [backgrounded, setSpaceBookingOpen]);
    var _o = __read(useState(null), 2), spacesWithConflicts = _o[0], setSpacesWithConflicts = _o[1];
    // TODO: This feels like a hack for referential stability of the isCheckingConflicts value.
    // We should find a better way to handle the usesSpaceConflictDetection hook input values
    // Tracks how many space conflict checks are currently in-flight. We use a
    // counter rather than a boolean because multiple spaces check in parallel —
    // flipping a boolean to false when the first space finishes would incorrectly
    // unblock submission while others are still pending. The counter reaches zero
    // only when every in-flight check has completed.
    var _p = __read(useState(0), 2), pendingConflictChecks = _p[0], setPendingConflictChecks = _p[1];
    var incrementConflictChecks = useCallback(function () { return setPendingConflictChecks(function (count) { return count + 1; }); }, []);
    var decrementConflictChecks = useCallback(
    // Math.max guards against going negative if a decrement fires without a
    // matching increment (e.g. an error thrown before the check started).
    function () { return setPendingConflictChecks(function (count) { return Math.max(0, count - 1); }); }, []);
    var updateSpaceConflicts = useCallback(function (spaceId, conflict) {
        var hasConflict = conflict.spaceBuffers.before ||
            conflict.spaceBuffers.after ||
            conflict.eventTime;
        setSpacesWithConflicts(function (prev) {
            var _a;
            if (hasConflict) {
                return __assign(__assign({}, (prev !== null && prev !== void 0 ? prev : {})), (_a = {}, _a[spaceId] = conflict, _a));
            }
            if (!prev || !(spaceId in prev)) {
                return prev;
            }
            var _b = prev, _c = spaceId, _removed = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
            return Object.keys(rest).length === 0 ? null : rest;
        });
    }, []);
    var clearSpaceConflict = useCallback(function (spaceId) {
        setSpacesWithConflicts(function (prev) {
            if (!prev || !(spaceId in prev)) {
                return prev;
            }
            var _a = prev, _b = spaceId, _removed = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return Object.keys(rest).length === 0 ? null : rest;
        });
    }, []);
    var removeSpaceInvitee = useEventApi({
        onError: onError,
        apiUrl: environmentUrls.apiUrl,
        baseApiUrl: environmentUrls.baseApiUrl,
        currentOrg: userContext.currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).removeSpaceInvitee;
    /* Create specific removeSpace function */
    var removeSpace = useCallback(function (spaceId, spaceInviteeId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentSpaces, currentEventId, result, _a, updatedSpaces;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    clearSpaceConflict(spaceId);
                    currentSpaces = getValues('spaces');
                    if (!(currentSpaces === null || currentSpaces === void 0 ? void 0 : currentSpaces.length))
                        return [2 /*return*/];
                    if (!spaceInviteeId) return [3 /*break*/, 4];
                    currentEventId = formData === null || formData === void 0 ? void 0 : formData.eventId;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, removeSpaceInvitee(currentEventId, spaceInviteeId)];
                case 2:
                    result = _b.sent();
                    if (!result)
                        return [2 /*return*/];
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/];
                case 4:
                    updatedSpaces = currentSpaces.filter(function (space) { return space.id !== spaceId; });
                    setValue('spaces', updatedSpaces, { shouldDirty: true });
                    return [2 /*return*/];
            }
        });
    }); }, [
        setValue,
        formData === null || formData === void 0 ? void 0 : formData.eventId,
        removeSpaceInvitee,
        getValues,
        clearSpaceConflict,
    ]);
    var removePendingSpace = useCallback(function (pendingSpaceSwap) {
        var spaceId = pendingSpaceSwap.spaceId, spaceInviteeId = pendingSpaceSwap.spaceInviteeId;
        if (!spaceId && !spaceInviteeId)
            return;
        removeSpace(spaceId, spaceInviteeId).finally(function () {
            setPendingSpaceSwap(null);
        });
    }, [removeSpace]);
    /* This assume the event being created/edited is only for a single space and that space is managed(request only) */
    var requestOnlySpace = ((_b = formData === null || formData === void 0 ? void 0 : formData.spaces) === null || _b === void 0 ? void 0 : _b.length) === 1 && ((_d = (_c = formData === null || formData === void 0 ? void 0 : formData.spaces) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.isManaged)
        ? (_e = formData === null || formData === void 0 ? void 0 : formData.spaces) === null || _e === void 0 ? void 0 : _e[0]
        : undefined;
    var spaceRequestFormData = 
    /* @TODO this name is misleading, this just gets the space */
    useGetSpaceByIdForDraftEventMeetingServicePermissionQuery({
        variables: { spaceId: ((_f = requestOnlySpace === null || requestOnlySpace === void 0 ? void 0 : requestOnlySpace.id) === null || _f === void 0 ? void 0 : _f.toString()) || '' },
        skip: !(requestOnlySpace === null || requestOnlySpace === void 0 ? void 0 : requestOnlySpace.id),
    }).data;
    // Guard on requestOnlySpace: Apollo retains the last data after `skip`
    // flips true, so without it a removed request-only space would leave a
    // stale requestFormId behind (and validation keys off requestFormId).
    var requestFormId = requestOnlySpace
        ? (_h = (_g = spaceRequestFormData === null || spaceRequestFormData === void 0 ? void 0 : spaceRequestFormData.getSpaceById) === null || _g === void 0 ? void 0 : _g.requestForm) === null || _h === void 0 ? void 0 : _h.id
        : undefined;
    var _q = __read(useState('unknown'), 2), spaceRequestFormCompletion = _q[0], setSpaceRequestFormCompletion = _q[1];
    var _r = __read(useState(false), 2), hasAttemptedSubmit = _r[0], setHasAttemptedSubmit = _r[1];
    var contextValue = useMemo(function () { return (__assign(__assign({}, userPermissions), { removeSpace: removeSpace, removePendingSpace: removePendingSpace, userPermissions: userPermissions, timezone: timezone, timeFormat: timeFormat, requestOnlySpace: requestOnlySpace, requestFormId: requestFormId, spaceRequestFormCompletion: spaceRequestFormCompletion, setSpaceRequestFormCompletion: setSpaceRequestFormCompletion, hasAttemptedSubmit: hasAttemptedSubmit, setHasAttemptedSubmit: setHasAttemptedSubmit, composerMode: composerMode, backgrounded: backgrounded, locationId: locationId, levelId: levelId, setLocationId: setLocationId, setLevelId: setLevelId, loading: locationLevelLoading, onError: onError, onTrackBufferEvent: onTrackBufferEvent, setSpaceBookingOpen: setSpaceBookingOpen, pendingSpaceSwap: pendingSpaceSwap, setPendingSpaceSwap: setPendingSpaceSwap, spacesWithConflicts: spacesWithConflicts, isCheckingConflicts: pendingConflictChecks > 0, updateSpaceConflicts: updateSpaceConflicts, clearSpaceConflict: clearSpaceConflict, incrementConflictChecks: incrementConflictChecks, decrementConflictChecks: decrementConflictChecks })); }, [
        removeSpace,
        removePendingSpace,
        userPermissions,
        timezone,
        timeFormat,
        requestOnlySpace,
        requestFormId,
        spaceRequestFormCompletion,
        hasAttemptedSubmit,
        composerMode,
        backgrounded,
        locationId,
        levelId,
        setLocationId,
        setLevelId,
        locationLevelLoading,
        onError,
        onTrackBufferEvent,
        setSpaceBookingOpen,
        pendingSpaceSwap,
        setPendingSpaceSwap,
        spacesWithConflicts,
        pendingConflictChecks,
        updateSpaceConflicts,
        clearSpaceConflict,
        incrementConflictChecks,
        decrementConflictChecks,
    ]);
    return (_jsx(EventComposerGlobalContext.Provider, { value: contextValue, children: children }));
};
export var useEventComposerGlobalContext = function () {
    return useContext(EventComposerGlobalContext);
};
